module.exports = __webpack_public_path__ + "static/img/interface.d7844cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/assets/interface.png
// module id = IQ5q
// module chunks = 0